import { BrowserRouter as BRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Pages from "./pages";

import {
  LandingScreen,
  InputPhoneNum,
  VerifyOtp,
  OlduserError,
  WebError,
  CongratsScreen,
  KitAssignedAlready
} from "./cc";

import { CardUser, NonCardUser } from "./RepublicCamp";

import { Wazirx, WazirxTAndC } from "./WazirxPartnership";

import RepublicQuiz from './RepublicDayCamp2025';

import ValentineLandingScreen, { ValentinesFaq, ValentinesTnC } from "./ValentineDayCampaign";

import RewardStore from "./RewardStore";

import { WorldCupFAQ } from "./components/IPL2026";

import MonthBonanza, { MonthEndBonanzaFaq, MonthEndBonanzaTnC } from "./components/NewYearCamp2026";

import GoForGold from "./GoForGold";
import { CAMPAIGN_START, CAMPAIGN_END } from "./GoForGold/campaign";

import Home from "./pages/Home";
import TermsAndCondition from "./pages/TermsAndCondition";

function CampaignRouter() {
  const now = Date.now();
  if (now >= CAMPAIGN_START.getTime() && now <= CAMPAIGN_END.getTime()) {
    return <GoForGold />;
  }
  return <MonthBonanza />;
}

function App() {

  return (
    <div className="App">
      <BRouter>
        <Routes>
          {/* Republic Day Campaign */}
          <Route path="/card/:type" element={<CardUser />} />
          <Route path="/noncard" element={<NonCardUser />} />

          {/* Christmas Campaign Routes */}
          <Route path="/" element={<Pages.Landing />} />
          <Route path="/welcome" element={<Pages.Welcome />} />
          <Route path="/rewards" element={<Pages.Rewards />} />

          {/* IPL Campaign 2026 */}
          {/* <Route path="/home" element={<Home />} /> */}
          <Route path="/TermsAndCondition" element={<TermsAndCondition />} />
          <Route path="/faq" element={<WorldCupFAQ />} />

          {/* Card Campaign Routes */}
          <Route path="/cc/:id" element={<LandingScreen />} />
          <Route path="/cc/inputPhoneNum" element={<InputPhoneNum />} />
          <Route path="/cc/verifyOtp" element={<VerifyOtp />} />
          <Route path="/cc/olduserError" element={<OlduserError />} />
          <Route path="/cc/congrats" element={<CongratsScreen />} />
          <Route path="/cc/error" element={<WebError />} />
          <Route path="/cc/kitassignedalready" element={<KitAssignedAlready />} />

          {/* Wazirx Partnership */}
          <Route path="/partnership/wazirx" element={<Wazirx />} />
          <Route path="/partnership/WazirxTAndC" element={<WazirxTAndC />} />

          {/* Republic Day Quiz */}
          <Route path="/quiz" element={<RepublicQuiz.RepublicQuiz />} />

          {/* Valentine's Day Campaign */}
          <Route path="/valentine/2024/:type" element={<ValentineLandingScreen />} />
          <Route path="/valentinesFaq" element={<ValentinesFaq />} />
          <Route path="/valentinesTnC" element={<ValentinesTnC />} />

          {/* Reward Store */}
          <Route path="/rewardStore" element={<RewardStore />} />

          {/* New Year / Month Bonanza Campaign */}
          <Route path="/home" element={<CampaignRouter />} />
          <Route path="/monthBonanzaFaq" element={<MonthEndBonanzaFaq />} />
          <Route path="/monthBonanzaTnC" element={<MonthEndBonanzaTnC />} />

          {/* Common Routes */}
          <Route path="/error" element={<Pages.Error />} />
        </Routes>
      </BRouter>
    </div>
  );
}

export default App;
